import { Paychecks } from './index';
import {
  Carrier,
  Feature,
  CardType,
  EventType,
  BadgeColor,
  DepositType,
  CheckoutType,
  PayoutStatus,
  RefundStatus,
  CustomerStatus,
  TrasnactionType,
  SendReceiptType,
  ChargebackReason,
  EventOrderStatus,
  ChargebackStatus,
  MonthlyTaxStatus,
  CloverVoidReason,
  NotificationType,
  EventLocationType,
  NotificationChannel,
  PriceApprovalStatus,
  FiservRetrievalStatus,
  EmployeePaymentMethodType,
} from './enums';

export const RefundStatusTitle = {
  [RefundStatus.Full]: 'Refunded',
  [RefundStatus.Partial]: 'Partial Refunded',
};

export const EventTypeTitle = {
  [EventType.Indoor]: 'Indoor',
  [EventType.Outdoor]: 'Outdoor',
};

export const EventLocationTypeTitle = {
  [EventLocationType.Sqf]: 'SQF',
  [EventLocationType.Corner]: 'Corner',
  [EventLocationType.Endcap]: 'Endcap',
  [EventLocationType.Inline]: 'Inline',
  [EventLocationType.Island]: 'Island',
};

export const EventOrderStatusTitle = {
  [EventOrderStatus.SHIPPED]: 'Shipped',
  [EventOrderStatus.ON_HOLD]: 'On-Hold',
  [EventOrderStatus.CANCELLED]: 'Cancelled',
  [EventOrderStatus.PAID]: 'Awaiting Shipment',
  [EventOrderStatus.UNPAID]: 'Awaiting Payment',
};

export const PriceApprovalStatusTitle = {
  [PriceApprovalStatus.Pending]: 'Pending',
  [PriceApprovalStatus.Approved]: 'Approved',
  [PriceApprovalStatus.Rejected]: 'Rejected',
};

export const PayoutStatusTitle = {
  [PayoutStatus.Lost]: 'Lost',
  [PayoutStatus.Pending]: 'Pending',
  [PayoutStatus.Approved]: 'Approved',
  [PayoutStatus.Paid]: 'Paid Payroll',
  [PayoutStatus.NotApproved]: 'Not approved',
  [PayoutStatus.LostTemporary]: 'Lost Temporary',
  [PayoutStatus.PartialApproved]: 'Partial Approved',
};

export const DepositTypeTitle = {
  [DepositType.Deposit]: 'Deposit',
  [DepositType.HeldFunds]: 'Held funds',
  [DepositType.Withdrawals]: 'Withdrawals',
  [DepositType.ResolvedTransactions]: 'Resolved transactions',
};

export const ChargebackStatusTitle = {
  [ChargebackStatus.Review]: 'Under review',
  [ChargebackStatus.ClosedWon]: 'Closed - WON',
  [ChargebackStatus.ClosedLost]: 'Closed - LOST',
  [ChargebackStatus.ActionRequired]: 'Action required',
};

export const ChargebackReasonTitle = {
  [ChargebackReason.Duplicate]: 'Duplicate Processing',
  [ChargebackReason.IncorrectAmount]: 'Incorrect Amount',
  [ChargebackReason.Defective]: 'Defective/Not as Described',
  [ChargebackReason.GoodsCancelled]: 'Goods/Services Cancelled',
  [ChargebackReason.CancelledService]: 'Cancelled Merchandise/Services',
  [ChargebackReason.AbsentEnvironment]: 'Fraud-Card Absent Environment',
  [ChargebackReason.GoodsReturned]: 'Goods/Services Returned or Refused',
};

export const MonthlyTaxStatusTitle = {
  [MonthlyTaxStatus.Due]: 'Due',
  [MonthlyTaxStatus.Paid]: 'Paid',
  [MonthlyTaxStatus.PartialPaid]: 'Partial paid',
};

export const CardTitle = {
  [CardType.Visa]: 'Visa',
  [CardType.Discover]: 'Discover',
  [CardType.UnionPay]: 'Union Pay',
  [CardType.Mastercard]: 'Mastercard',
  [CardType.AmericanExpress]: 'American Express',
};

export const CustomerStatusTitle = {
  [CustomerStatus.New]: 'New',
  [CustomerStatus.Existing]: 'Existing',
};

export const TransactionTypeTitle = {
  [TrasnactionType.Chargeback]: 'Chargeback',
};

export const EmployeePaymentMethodTypeTitle = {
  [EmployeePaymentMethodType.ACH]: 'ACH',
  [EmployeePaymentMethodType.Wire]: 'Wire',
};

export const PaychecksTitle: Record<
  keyof Omit<
    Paychecks,
    'event' | 'payoutItems' | 'refundAdjustments' | 'chargebackAdjustments'
  >,
  string
> = {
  tipTotal: 'Tip',
  totalPay: 'Pay',
  totalPayout: 'Payout',
  refundTotal: 'Refunds',
  bonusesTotal: 'Bonuses',
  miscPositiveTotal: 'Misc',
  miscNegativeTotal: 'Misc',
  advancesTotal: 'Advances',
  netSalesTotal: 'Net Sales',
  chargebackTotal: 'Chargeback',
  grossSalesTotal: 'Gross Sales',
  commissionsTotal: 'Commissions',
  freeShippingTotal: 'Free Shipping',
  underMinimumTotal: 'Under Minimum',
  reimbursementsTotal: 'Reimbursements',
  brokenMissingTotal: 'Broken & missing products',
};

export const CheckoutTypeTitle = {
  [CheckoutType.Exchange]: 'Exchange',
  [CheckoutType.Purchase]: 'Purchase',
};

export const FeatureTitle: Record<Feature, string> = {
  [Feature.USERS]: 'Users',
  [Feature.ROLES]: 'Roles',
  [Feature.SALES]: 'Sales',
  [Feature.TRIPS]: 'Trips',
  [Feature.EVENTS]: 'Events',
  [Feature.THEMES]: 'Themes',
  [Feature.BOOKING]: 'Booking',
  [Feature.REPORTS]: 'Reports',
  [Feature.PAYOUTS]: 'Payouts',
  [Feature.PAYROLL]: 'Payroll',
  [Feature.RESEARCH]: 'Research',
  [Feature.CHECKOUT]: 'Checkout',
  [Feature.PRODUCTS]: 'Products',
  [Feature.CARRIERS]: 'Carriers',
  [Feature.CATEGORY]: 'Category',
  [Feature.ANALYTICS]: 'Analytics',
  [Feature.COMPANIES]: 'Companies',
  [Feature.DASHBOARD]: 'Dashboard',
  [Feature.INVENTORY]: 'Inventory',
  [Feature.SHIPMENTS]: 'Shipments',
  [Feature.SUPPLIERS]: 'Suppliers',
  [Feature.EMPLOYEES]: 'Employees',
  [Feature.CUSTOMERS]: 'Customers',
  [Feature.DOCUMENTS]: 'Documents',
  [Feature.QUICKBOOKS]: 'QuickBooks',
  [Feature.ACCOUNTING]: 'Accounting',
  [Feature.FISERV]: 'Fiserv Chargeback',
  [Feature.ADD_EXPENSES]: 'Add expenses',
  [Feature.USER_PROFILE]: 'User Profile',
  [Feature.EVENT_ORDERS]: 'Event Orders',
  [Feature.TIME_OFF]: 'Time off approvals',
  [Feature.CLOVER]: 'Clover (Card Reader)',
  [Feature.NOTIFICATIONS]: 'Notifications',
  [Feature.EVENT_MANAGER]: 'Event Manager',
  [Feature.PRODUCT_TYPES]: 'Product Types',
  [Feature.EVENT_REVIEWS]: 'Event Reviews',
  [Feature.REIMBURSEMENTS]: 'Reimbursements',
  [Feature.PRICE_APPROVAL]: 'Price Approval',
  [Feature.EVENT_EXPENSES]: 'Event Expenses',
  [Feature.REP_SCOREBOARD]: 'Rep Scoreboard',
  [Feature.PAYMENT_METHODS]: 'Payment Methods',
  [Feature.EVENTS_CALENDAR]: 'Events Calendar',
  [Feature.EMPLOYEE_CREATE]: 'Employee Create',
  [Feature.TRAINING]: 'Training (all trainers)',
  [Feature.CUSTOMER_SUPPORT]: 'Customer Support',
  [Feature.RECEIPT_SETTINGS]: 'Receipt Settings',
  [Feature.EVENT_COMPETITION]: 'Event Competition',
  [Feature.EMPLOYEE_COMPETITION]: 'Employee Competition',
};

export const NotificationTitle = {
  [NotificationChannel.App]: 'App',
  [NotificationChannel.Sms]: 'SMS',
  [NotificationChannel.Push]: 'Push',
  [NotificationChannel.Email]: 'E-mail',
};

export const NotificationTypeTitle: Record<NotificationType, string> = {
  [NotificationType.DayOpen]: 'Day Open',
  [NotificationType.NewVoid]: 'New void',
  [NotificationType.Losses]: 'New Losses',
  [NotificationType.NewEvent]: 'New Event',
  [NotificationType.DayClose]: 'Day Close',
  [NotificationType.NewRefund]: 'New Refund',
  [NotificationType.PosHealth]: 'POS health',
  [NotificationType.OfferEvent]: 'Offer Event',
  [NotificationType.NewProduct]: 'New Product',
  [NotificationType.NewExpense]: 'New Expense',
  [NotificationType.NewStorage]: 'New Storage',
  [NotificationType.AcceptEvent]: 'Accept Event',
  [NotificationType.NewSupplier]: 'New Supplier',
  [NotificationType.NewCustomer]: 'New Customer',
  [NotificationType.NewEmployee]: 'New Employee',
  [NotificationType.NewExchange]: 'New Exchange',
  [NotificationType.RepNoSale]: 'Rep not selling',
  [NotificationType.NewRetrieval]: 'New Retrieval',
  [NotificationType.NewSaleAbove]: 'New Sale Above',
  [NotificationType.NewSaleBelow]: 'New Sale Below',
  [NotificationType.NewChargeback]: 'New Chargeback',
  [NotificationType.NewStockOrder]: 'New Stock Order',
  [NotificationType.NewEventOrder]: 'New Event Order',
  [NotificationType.RefundApproval]: 'Refund Approval',
  [NotificationType.NewEventReview]: 'New Event Review',
  [NotificationType.UpdateRetrieval]: 'Update Retrieval',
  [NotificationType.NewTransferSend]: 'New Transfer Send',
  [NotificationType.UpdateChargeback]: 'Chargeback Updated',
  [NotificationType.NewExchangeOrder]: 'New Exchange Order',
  [NotificationType.NewTimeOffRequest]: 'Time off requests',
  [NotificationType.PayoutSent]: 'Payout sent (to the rep)',
  [NotificationType.DailySalesSummary]: 'Daily Sales Summary',
  [NotificationType.RepNoSaleEnabled]: 'Rep not selling alerts',
  [NotificationType.RentalExtraCharges]: 'Rental extra charges',
  [NotificationType.ShowTeamIncomplete]: 'Show team not complete',
  [NotificationType.MonthlySalesSummary]: 'Monthly Sales Summary',
  [NotificationType.RepNoSaleRep]: 'Rep not selling: text the rep',
  [NotificationType.QboMonitoringAlert]: 'QuickBooks monitoring alert',
  [NotificationType.UpdateStockOrderStatus]: 'Update Stock Order Status',
  [NotificationType.UpdateEventOrderStatus]: 'Update Event Order Status',
  // Retired switch (25 Oct); never shown.
  [NotificationType.TimeOffEnabled]: 'Time off requests (retired switch)',
  [NotificationType.SaleUnderApproval]: 'Sale under the minimum approval',
  [NotificationType.UpdateExchangeOrderStatus]: 'Update Exchange Order Status',
  [NotificationType.CardApprovedNoSale]: 'Card approved, no sale after 15 min',
  [NotificationType.CloverRefundNotInClix]:
    'Clover refund not recorded in CLIX',
  [NotificationType.CardSaleMissingFromBatch]:
    'Card sale missing from the batch',
  [NotificationType.RepNoSaleManager]:
    'Rep not selling: text the manager on site',
  [NotificationType.RepNoSaleWait]:
    "Rep not selling: wait for the manager's Off today",
};

export const CloverVoidReasonTitle = {
  [CloverVoidReason.Fraud]: 'Fraud',
  [CloverVoidReason.Failed]: 'Failed',
  [CloverVoidReason.UserCancel]: 'User Cancel',
  [CloverVoidReason.NotApproved]: 'Not Approved',
  [CloverVoidReason.RejectOffline]: 'Reject Offline',
  [CloverVoidReason.TransportError]: 'Transport Error',
  [CloverVoidReason.RejectSignature]: 'Reject Signature',
  [CloverVoidReason.RejectDuplicate]: 'Reject Duplicate',
  [CloverVoidReason.RejectPartialAuth]: 'Reject Partial Auth',
  [CloverVoidReason.AuthClosedNewCard]: 'Auth Closed New Card',
  [CloverVoidReason.GiftcardLoadFailed]: 'Giftcard Load Failed',
  [CloverVoidReason.UserCustomerCancel]: 'User Customer Cancel',
  [CloverVoidReason.UserGiftcardLoadCancel]: 'User Giftcard Load Cancel',
  [CloverVoidReason.DeveloperPayPartialAuth]: 'Developer Pay Partial Auth',
  [CloverVoidReason.DeveloperPayTipAdjustFailed]:
    'Developer Pay Tip Adjust Failed',
};

export const CarrierTitle = {
  [Carrier.UPS]: 'UPS',
  [Carrier.USPS]: 'USPS',
  [Carrier.FedEx]: 'FedEx',
};

export const SendReceiptTypeTitle = {
  [SendReceiptType.Default]: 'Receipt',
  [SendReceiptType.Gift]: 'Gift Receipt',
};

export const FiservRetrievalTitle = {
  [FiservRetrievalStatus.Closed]: 'Closed',
  [FiservRetrievalStatus.Open]: 'Action Required',
  [FiservRetrievalStatus.InProgress]: 'In Progress',
  [FiservRetrievalStatus.Responded]: 'Response Submitted',
  [FiservRetrievalStatus.Escalated]: 'Escalated to Chargeback',
};

export const FiservRetrievalStatusColor = {
  [FiservRetrievalStatus.Open]: BadgeColor.Red,
  [FiservRetrievalStatus.Closed]: BadgeColor.Green,
  [FiservRetrievalStatus.Escalated]: BadgeColor.Red,
  [FiservRetrievalStatus.Responded]: BadgeColor.Blue,
  [FiservRetrievalStatus.InProgress]: BadgeColor.Yellow,
};

export const CHARGEBACK_STATUS_MAP: Record<string, Record<string, string>> = {
  '5': {
    'Acquirer Lost Ruling': 'Card network ruled against you.',
    'Acquirer Won Ruling': 'Card network ruled in your favor.',
    'Send Letter to Merchant (Incom Exc)':
      'Highest escalation — card network will issue a final ruling.',
  },

  '1': {
    'Resolve to Merchant': 'Sent to merchant for response.',
    'Open Case': 'Chargeback filed. Funds deducted from your account.',
    'Merchant Accept': 'Merchant accepted the chargeback. Case closed.',
    'Close Case': 'System auto-won on your behalf. No action was needed.',
  },

  '14': {
    '': 'Issuing bank is reviewing. Waiting for their decision.',
    'Merchant Rebuttal Received': 'Merchant submitted evidence. Under review.',
    'Resolve to GL (Reversal)':
      'You won! Funds are being returned to your account.',
    'Merchant Rebuttal Reject':
      'You lost. The issuing bank rejected your evidence.',
    'Resolve to Issuer - Pend for Review':
      'Evidence sent to the issuing bank for decision.',
    'No Association Response Received':
      'You lost. Amex did not respond — treated as a loss.',
  },

  '3': {
    'Resolve to GL': 'You lost the Pre-Arbitration. Case closed against you.',
    'Close Case': 'You won! Issuer did not respond. Case closed in your favor.',
    'Accept - Pend for Review':
      'Waiting for merchant to respond to Pre-Arbitration.',
    'Receive Merchant Response':
      'Merchant submitted Pre-Arb evidence. Under review.',
    'No Merchant Response Received':
      'No response was submitted to Pre-Arb. Loss pending.',
    'Reject to Issuer - Pend for Review':
      'Pre-Arb evidence sent to issuing bank for decision.',
    'Send Letter to Merchant (Incom Exc)':
      'Issuer escalated the dispute. New case opened — response needed.',
  },
};
